import { MapsAPILoader } from '@agm/core';
import { ViewportScroller } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import { CaptchaCheckComponent } from 'src/app/account/auth/login/captcha-check/captcha-check.component';
import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { CustomValidators } from 'src/app/core/providers/custom.validator';
import { PasswordValidator } from 'src/app/core/providers/password.validator';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { AuthAlertService } from 'src/app/core/services/AlertService/auth-alert.service';
import { LocationsService } from 'src/app/core/services/locations/locations.service';
import { ApiService } from 'src/app/services/api';
import { BreadcrumbService } from 'src/app/services/breadcrumb';
import { noWhiteSpaceValidator } from 'src/app/shared/directive/validators';
import { AppState } from 'src/app/store/app.state';
import { setLoadingSpinner } from 'src/app/store/sharedstate/shared.actions';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-merchant-signup',
  templateUrl: './merchant-signup.component.html',
  styleUrls: ['./merchant-signup.component.scss']
})
export class MerchantSignupComponent implements OnInit, AfterViewInit {

  breadcrumbItems: breadcrumbItem[] = [
    {
      label:'Home',
      active:false,
      url:'/home'
    },
    {
      label: 'Merchants',
      active: false,
      url:"/merchants"
    },
    {
      label:'Sign Up',
      active:true,
      url: "",
    },
  ];

    @ViewChild("search")
    public search: ElementRef;
    public searchControl: FormControl;
    pageYoffset: any;
    placeholder:string = '201-555-0123'
    @HostListener("window:scroll", ["$event"]) onScroll(event) {
      this.pageYoffset = window.pageYOffset;
    }
    successmessage: any = ""
    errormessage: any = ""
    pinError: String = '';
    pin: string = '';
    @ViewChild("ngOtpInput") public ngOtpInputRef: any;
    @ViewChild("ngOtpInputTwo") public ngOtpInputTwoRef: any;
    @ViewChild(CaptchaCheckComponent) cpatchaRef: CaptchaCheckComponent;
    Country_Code_change :string ='';
    constructor(
      private store: Store<AppState>,
      private mapsAPILoader: MapsAPILoader,
      private cookieService: CookieService,
      private ngZone: NgZone,
      private scroll: ViewportScroller,
      private router: Router,
      private toastr: AuthAlertService,
      private toastr2: AlertService,
      private http: HttpClient,
      private locationService: LocationsService,
      private apiService: ApiService,
      private BreadcrumbService: BreadcrumbService,
      private alertService: AuthAlertService,
      private ApiService: ApiService,
    ) {
      this.preferredCountries = []
      const navigation = this.router.getCurrentNavigation();
      const state = navigation?.extras?.state as { message: string }
      if (state?.message) {
        this.alertService.success(state?.message)
      }
    }
    ngOtpInput: any;
    // config = {
    //   allowNumbersOnly: true,
    //   length: 4,
    //   isPasswordInput: false,
    //   disableAutoFocus: true,
    //   placeholder: "-",
    //   inputStyles: {
    //     width: "40px",
    //     height: "40px",
    //     fontSize: "13px",
    //     padding: '15px'
    //   },
    // };
    configTwo = {
      allowNumbersOnly: true,
      length: 4,
      isPasswordInput: false,
      disableAutoFocus: true,
      placeholder: "-",
      inputStyles: {
        width: "20.5%",
        height: "60px",
        fontSize: "13px",
        padding: '15px',
        marginRight: '20px',
        marginTop: '15px',
        marginBottom: '15px',
        textAlign: 'center'
      },
    };
    signupForm = new FormGroup({
      userDetails: new FormGroup({
        firstName: new FormControl("", [Validators.required, noWhiteSpaceValidator]),
        lastName: new FormControl("", [Validators.required, noWhiteSpaceValidator]),
        userEmail: new FormControl("", [Validators.required, Validators.email]),
        userPassword: new FormControl("", [
          Validators.required,
          PasswordValidator.minLength,
          PasswordValidator.maxLength,
          PasswordValidator.uppercase,
          PasswordValidator.lowercase,
          PasswordValidator.oneNumber
        ]),
        cPassword: new FormControl("", [
          Validators.required,
          // PasswordValidator.minLength,
          // PasswordValidator.maxLength,
          // PasswordValidator.uppercase,
          // PasswordValidator.lowercase,
          // PasswordValidator.oneNumber
        ]),
        phone: new FormControl(undefined, Validators.required),
        country: new FormControl(null, Validators.required)
      },
        CustomValidators.mustMatch('userPassword', 'cPassword')
      ),
      restaurantDetails: new FormGroup({
        restaurantName: new FormControl("", Validators.required),
        restaurantType: new FormControl(null, Validators.required),
        addressOne: new FormControl("", Validators.required),
        addressTwo: new FormControl(""),
        city: new FormControl("", Validators.required),
        state: new FormControl("", Validators.required),
        zipcode: new FormControl("", Validators.required),
        sellerAgreement: new FormControl(false, Validators.requiredTrue),
        // pin: new FormControl("", [Validators.minLength(4), Validators.maxLength(4)]),
      }),
    });
    submitted = false;

    error = "";
    successmsg = false;
    page = 1;

    // set the currenr year
    year: number = new Date().getFullYear();

    separateDialCode = true;
    SearchCountryField = SearchCountryField;
    CountryISO = CountryISO;
    preferredCountries: CountryISO[] ;
    googleAuth = localStorage.getItem('google_auth')
    facebookAuth = localStorage.getItem('facebook_auth')
    appleAuth = localStorage.getItem('apple_auth')
    hasSSOAuthData = false
    googleAuthData = null
    facebookAuthData = null
    appleAuthData = null


    ngAfterViewInit(): void {
      //throw new Error("Method not implemented.");
      // this.getCurrentlocationDetails();
    }

    showCaptcha: Boolean = true;
    securityCheckVerify: Boolean = false;
    captchaConfig: any = {
      type: 1,
      length: 5,
      cssClass: 'custom',
      back: {
        stroke: "#2F9688",
        solid: "#f7f7f7"
      },
      font: {
        color: "#000000",
        size: "35px"
      }
    };
    captchaLoading: Boolean = false;

    onCaptchaVerified() {
      console.log("Captcha verified successfully");
      this.captchaLoading = true;
      setTimeout(() => {
        this.captchaLoading = false;
      }, 1500)
      //this.modalService.dismissAll(this.securityCheckModal)
    }
    closeSecurityCheckModal(event) {
      this.securityCheckVerify = event
      //this.modalService.dismissAll(this.securityCheckModal)
    }

    ngOnInit() {
      this.store.dispatch(setLoadingSpinner({ status: true }));
      const userCountry = this.locationService.getUserCountry();
      this.preferredCountries = userCountry === CountryISO.UnitedKingdom
      ? [CountryISO.UnitedKingdom]
      : [userCountry, CountryISO.UnitedKingdom];
      this.BreadcrumbService.setValue(this.breadcrumbItems);
      // this.getCurrentlocationDetails();

        // if (this.googleAuth || this.facebookAuth || this.appleAuth) {
        //   this.hasSSOAuthData = true
        // }

        // if (this.googleAuth) {
        //   this.googleAuthData = JSON.parse(this.googleAuth);

        //   this.signupForm.patchValue({
        //     userDetails: {
        //       firstName: this.googleAuthData.given_name,
        //       lastName: this.googleAuthData.family_name,
        //       userEmail: this.googleAuthData.email,
        //     }
        //   })
        // } else if (this.facebookAuth) {
        //   this.facebookAuthData = JSON.parse(this.facebookAuth);

        //   this.signupForm.patchValue({
        //     userDetails: {
        //       firstName: this.facebookAuthData.first_name,
        //       lastName: this.facebookAuthData.last_name,
        //       userEmail: this.facebookAuthData.email,
        //     }
        //   })
        // } else if (this.appleAuth) {
        //   this.appleAuthData = JSON.parse(this.appleAuth);

        //   this.signupForm.patchValue({
        //     userDetails: {
        //       firstName: this.appleAuthData.firstName,
        //       lastName: this.appleAuthData.lastName,
        //       userEmail: this.appleAuthData.email,
        //     }
        //   })
        // }
        this.mapsAPILoader.load().then(() => {
        });
        // this.store.dispatch(setLoadingSpinner({ status: false }));
      this.getCurrentlocationDetails()
    }

    currentUserDetails:any
    // ##ATTACHED *ngIf="currentCountryISO !== ''" on the HTML for Proper Execution of the Form
    currentCountryISO = "";
    getCurrentlocationDetails(){
      // this.apiService.currentLocationDetails
      this.currentUserDetails = JSON.parse(this.apiService.getCurrentLocationDetails());
      console.log("this.apiService.currentLocationDetails", this.currentUserDetails)
      if (this.currentUserDetails) {
        this.currentCountryISO = this.currentUserDetails.country_code;
        setTimeout(() => {
          this.Country_Code_change = this.currentUserDetails.country_code;
        }, 1000);
        console.log("this.apiService.currentLocationDetails", this.Country_Code_change)
      }
      // Empty email and password fields
      this.signupForm.get('userDetails.userEmail').setValue('');
      this.signupForm.get('userDetails.userPassword').setValue('');
      this.store.dispatch(setLoadingSpinner({ status: false }));
    }
    onCountryChange(event: any) {
      this.Country_Code_change = event.iso2.toUpperCase();
    }


    // convenience getter for easy access to userDetails fields
    get userDetails() {
      return this.signupForm.controls['userDetails']['controls']
    }
    // convenience getter for easy access to restaurantDetails fields
    get restaurantDetails() {
      return this.signupForm.controls['restaurantDetails']['controls']
    }

    /**
     * On submit form
     */
    onSubmit() {
      this.submitted = true;
      if (this.pin.length != 4) {
        this.pinError = "Please fill all pin"
        return
      }

      // stop here if form is invalid
      if (this.signupForm.invalid) {
        return;
      }
      this.pinError = '';
    }

    goToLoginPage() {
      console.log("helooo");

      this.toastr.clear();
      localStorage.removeItem('google_auth');
      localStorage.removeItem('facebook_auth');
      localStorage.removeItem('apple_auth');
      this.ngZone.run(() => {
        this.router.navigate(['/account/login']).then(() => window.location.reload());
      });
    }

    // countryNotSelectedError = false;
    /**
     * Moves to the next page of the signup process.
     * Validates the form fields and displays error messages if necessary.
     * Autocompletes the restaurant address using Google Maps API.
     */
    onClickSignUp() {
      // if (!this.securityCheckVerify) {
      //   this.alertService.clear();
      //   this.alertService.error("Please verify captcha.")
      //   return
      // }

      if (this.signupForm.controls.restaurantDetails.invalid) {
        return;
      }
      this.captchaLoading = true;
      // this.onNextPage()
      // this.showCaptcha = false;
      // this.verifyOTPCode()
      this.merchantOnboard()
    }

    onNextPage() {
      if(this.signupForm.get('userDetails.country').value == "null") {
        // console.log("this.signupForm.get('userDetails.country').value", this.signupForm.get('userDetails.country').value)
        this.submitted = false;
        // this.countryNotSelectedError = true;
        return;
      } else {
        // this.countryNotSelectedError = false;
        this.submitted = true;
      }

      if (this.signupForm.controls.userDetails.invalid && this.page == 1) {
        return;
      }

      if (this.googleAuth) {
        const isGoogleFirstNameSame = this.googleAuthData.given_name === this.signupForm.get('userDetails.firstName').value
        const isGoogleLastNameSame = this.googleAuthData.family_name === this.signupForm.get('userDetails.lastName').value
        const isGoogleEmailSame = this.googleAuthData.email === this.signupForm.get('userDetails.userEmail').value

        if ((!isGoogleFirstNameSame || !isGoogleLastNameSame || !isGoogleEmailSame) && this.page == 1) {
          this.toastr.clear();
          this.toastr.error('Please use your Google account details.')
          return
        }
      } else if (this.facebookAuth) {
        const isFacebookFirstNameSame = this.facebookAuthData.given_name === this.signupForm.get('userDetails.firstName').value
        const isFacebookLastNameSame = this.facebookAuthData.family_name === this.signupForm.get('userDetails.lastName').value
        const isFacebookEmailSame = this.facebookAuthData.email === this.signupForm.get('userDetails.userEmail').value

        if ((!isFacebookFirstNameSame || !isFacebookLastNameSame || !isFacebookEmailSame) && this.page == 1) {
          this.toastr.clear();
          this.toastr.error('Please use your Facebook account details.')
          return
        }
      } else if (this.appleAuth) {
        if (this.appleAuthData.firstName && this.appleAuthData.lastName) {
          const isAppleFirstNameSame = this.appleAuthData.firstName === this.signupForm.get('userDetails.firstName').value
          const isAppleLastNameSame = this.appleAuthData.lastName === this.signupForm.get('userDetails.lastName').value
          const isAppleEmailSame = this.appleAuthData.email === this.signupForm.get('userDetails.userEmail').value

          if ((!isAppleFirstNameSame || !isAppleLastNameSame || !isAppleEmailSame) && this.page == 1) {
            this.toastr.clear();
            this.toastr.error('Please use your Apple account details.')
            return
          }
        } else {
          const isAppleEmailSame = this.appleAuthData.email === this.signupForm.get('userDetails.userEmail').value

          if ((!isAppleEmailSame) && this.page == 1) {
            this.toastr.clear();
            this.toastr.error('Please use your Apple account details.')
            return
          }
        }
      }

      this.page = this.page + 1;

      this.scrollToTop();
      this.submitted = false;
      // this.countryNotSelectedError = false;
      var componentForm = {
        street_number: 'short_name',
        locality: 'long_name',
        administrative_area_level_1: 'long_name',
        country: 'long_name',
        postal_code: 'short_name'
      };
      this.searchControl = new FormControl();
      setTimeout(() => {
        const search = document.getElementById("search") as HTMLInputElement;
        let autocomplete1 = new google.maps.places.Autocomplete(search, {
          fields: ["address_components", "geometry"],
          types: ["address"]
        });
        autocomplete1.addListener("place_changed", () => {
          this.ngZone.run(() => {
            //get the place result
            let place: google.maps.places.PlaceResult = autocomplete1.getPlace();
            console.log("place", place)
            if (place && place.address_components) {
              for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];
                console.log("addressType", addressType)
                if (componentForm[addressType]) {
                  var val = place.address_components[i][componentForm[addressType]];
                  console.log("val", val)
                  if (addressType == "route") {
                    // this.merchantAddress1 = val;
                    this.restaurantDetails.addressOne.setValue(val)
                  }
                  if (addressType == "locality") {
                    this.restaurantDetails.city.setValue(val)
                  }
                  if (addressType == "administrative_area_level_1") {
                    this.restaurantDetails.state.setValue(val)
                  }
                  if (addressType == "postal_code") {
                    this.restaurantDetails.zipcode.setValue(val)
                  }
                  // if (addressType == "country") {
                  //   this.restaurantDetails.country.setValue(val)
                  // }
                }
              }
            }
             this.submitted = true;
            // this.merchantAddress1 = place.name;
            //verify result
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
          });
        });
      }, 1000);
    }
    onPrevPage() {
      this.page = this.page - 1;
      this.scrollToTop();
    }
    scrollToTop() {
      this.scroll.scrollToPosition([0, 0]);
    }
    otpType: any = ""
    otpTypechooseError = false;
    Emailphone:any
    chooseOtpServiceType(event: any) {
      this.Emailphone = event.target.value
      this.type = event.target.value
      this.errormessage = ""
      this.successmessage = ""
    }
    token: any = '';
    employeeId: any = "";
    merchantId: any = "";
    storeId: any = "";
    headerToken = { 'Content-Type': 'application/json', 'Authorization': this.token }
    httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    GLOBALURL = environment.globalUrlApi;
    apikey = environment.googleApiKey
    type: Number = 1;
    showLoader: Boolean = false
    otpErrorMsg: Boolean = false
    sendCode() {
      if (this.type == 0) {
        this.toastr.clear();
        this.toastr.error("Please choose where you'd like to receive your OTP. Select an option to continue")
      } else {

        this.errormessage = ""
        this.sendOtpCode()
      }
    }
    sendOtpCode() {
      this.showLoader = true
      this.otpErrorMsg = false
      let form1 = this.signupForm.get('userDetails').value
      let form2 = this.signupForm.get('restaurantDetails').value
      //console.log(typeof(form))
      let form = { ...form1, ...form2 }
      var type = this.type
      let params = {
        otpType: +this.type,
        username: form.userEmail,
        firstName: form.firstName,
        lastName: form.lastName,
        password: form.userPassword,
        mobile: form.phone.internationalNumber,
        merchantCountry: form.country,
        merchantName: form.restaurantName,
        restaurantType: form.restaurantType,
        address1: form.addressOne,
        address2: form.addressTwo,
        city: form.city,
        state: form.state,
        zipcode: +form.zipcode,
        // pin: +form.pin,
        sellerAgreement: form.sellerAgreement
      }
      return this.http.post(this.GLOBALURL + '/user/register', params, this.httpOptions).subscribe((response: any) => {
        if (response.success === 1) {
          // this.toastr.success(response.message);
          // this.successmessage = response.message
          // this.clearMessage()
          this.toastr.clear();
          this.toastr.success(response.message)
          this.token = response.response.token;
          this.employeeId = response.response.employeeId
          this.merchantId = response.response.merchantId
          this.storeId = response.response.storeId
          this.headerToken['Authorization'] = this.token;
          this.showLoader = true
          this.page = 4;
          this.showLoader = false;
          this.disabledConfirmBtn = false;
          this.countdownFunction();
        } else {
          this.showLoader = false;
          // this.errormessage = response.message
          // this.clearMessage()
          //this.toastr.error(response.message)
          this.toastr.clear();
          this.toastr.error(response.message)
        }
      }, (error) => {
        this.showLoader = false;
        // let message = error.error.message;
        // if (message.includes('Http failure response for (unknown url): 0 Unknown Error')) message = 'Please check the internet connection';

        if (error === 'This username has already been registered.') {
          this.toastr.clear();
          this.toastr.error('This email has already been registered.')
          return
        }
        this.toastr.clear();
        this.toastr.error(error);
        //console.log(error)
      });
    }

    updateMerchantOnboard(merchantId: any) {
      var params = {
        merchantId: merchantId,
        // merchantName: merchant.merchantName,
        status: 2
      };
      // console.log("Update entered")
      this.http
        .put(this.GLOBALURL + "/merchant/statusUpdate", params, this.httpOptions2)
        .subscribe(
          (response: any) => {
            // console.log("done update", response);
            if (response.success == 0) {
              this.toastr.error(response.message);
            } else {
              // this.toastr.success(response.message);
              this.showLoader = false;
          this.disabledConfirmBtn = false;
          setTimeout(() => {
            this.ngZone.run(() => {
              // const navigationExtras = { state: { message: 'Registration Successfull' } };
              // this.router.navigate(['/account/login'], navigationExtras).then(() => window.location.reload());
              // route to merhcant list
              this.router.navigate(['/merchants']);
              this.toastr2.clear();
            });
           }, 1500);
          // this.countdownFunction();
            }
          },
          (error) => {
            const message = this.ApiService.errorMessage(error)
            this.toastr.error(message);
          });
    }

    merchantOnboard() {
      this.showLoader = true
      this.otpErrorMsg = false
      let form1 = this.signupForm.get('userDetails').value
      let form2 = this.signupForm.get('restaurantDetails').value
      //console.log(typeof(form))
      let form = { ...form1, ...form2 }
      var type = this.type
      let params = {
        otpType: +this.type ? +this.type : 1,
        username: form.userEmail,
        firstName: form.firstName,
        lastName: form.lastName,
        password: form.userPassword,
        mobile: form.phone.internationalNumber,
        merchantCountry: form.country,
        merchantName: form.restaurantName,
        restaurantType: form.restaurantType,
        storeType: form.restaurantType,
        address1: form.addressOne,
        address2: form.addressTwo,
        city: form.city,
        state: form.state,
        zipcode: +form.zipcode,
        // pin: +form.pin,
        status: 2,
        sellerAgreement: form.sellerAgreement
      }
      return this.http.post(this.GLOBALURL + '/user/merchantregister', params, this.httpOptions).subscribe((response: any) => {
        if (response.success === 1) {
          // this.toastr.success(response.message);
          // this.successmessage = response.message
          // this.clearMessage()
          let merchantId = response.response?.merchantId;
          this.updateMerchantOnboard(merchantId)
          this.toastr2.clear();
          this.toastr2.success(response.message)
          // this.token = response.response.token;
          // this.employeeId = response.response.employeeId
          // this.merchantId = response.response.merchantId
          // this.storeId = response.response.storeId
          // this.headerToken['Authorization'] = this.token;
          // this.showLoader = true
          // this.page = 4;


        } else {
          this.showLoader = false;
          // this.errormessage = response.message
          // this.clearMessage()
          //this.toastr.error(response.message)
          this.toastr2.clear();
          this.toastr2.error(response.message)
        }
      }, (error) => {
        this.showLoader = false;
        // let message = error.error.message;
        // if (message.includes('Http failure response for (unknown url): 0 Unknown Error')) message = 'Please check the internet connection';

        if (error === 'This username has already been registered.') {
          this.toastr2.clear();
          this.toastr2.error('This email has already been registered.')
          return
        }
        this.toastr2.clear();
        this.toastr2.error(error);
        //console.log(error)
      });
    }
    clearMessage() {
      setTimeout(() => {
        this.successmessage = ""
        this.errormessage = ""
      }, 3000)
    }
    countdown: number = 120;
    countdownDisplay: any = "2:00";;
    countdownTimer: any;
    disabledResendOtp: boolean = true;
    disabledConfirmBtn: Boolean = false;
    countdownFunction() {
      this.countdown = 120;
      this.disabledResendOtp = true;
      clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        this.countdownDisplay = this.formatTime(this.countdown);
        if (this.countdown == 1) {
          clearInterval(this.countdownTimer)
        }
        this.countdown--
        if (this.countdown == 0) {
          this.disabledResendOtp = false;
          this.disabledConfirmBtn = true;
        } else {
          this.disabledResendOtp = true;
        }
      }, 1000);
    }
    formatTime(seconds: number) {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      const paddedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
      return `${minutes}:${paddedSeconds}`;
    }
    disabledButtonWhenRegisterSucessfully: boolean = true;
    otpCode: string = "";
    httpOptions2 = { headers: new HttpHeaders(this.headerToken) };
    userName: any = "";
    verifyOTPCode() {
      this.showLoader = true
      this.otpErrorMsg = false
      var params = {
        otpType: 1,
        employeeId: this.employeeId,
        token: this.token,
        merchantId: this.merchantId,
        storeId: this.storeId,
        // otp: +this.otp,
        generationType: "register"
      }
      return this.http.put(this.GLOBALURL + '/user/verify', params, this.httpOptions2).subscribe((response: any) => {
        if (response.success == 0) {
          // this.successmessage = response.message
          // this.clearMessage()
          this.toastr.clear();
          this.toastr.error(response.message);
          this.otpErrorMsg = true
          this.ngOtpInputTwoRef.setValue("");
          this.showLoader = false
        } else {
          // this.successmessage = "Registration Successfull"
          // this.clearMessage()
          //this.toastr.error(response.message);
          // this.toastr.clear();
          // this.toastr.success("Registration Successfull");
          this.showLoader = false
          this.disabledButtonWhenRegisterSucessfully = false;
          if (response.response.mobile) {
            this.userName = response.response.mobile;
          } else if (response.response.username) {
            this.userName = response.response.username;
          }
          // this.page = 1
          this.ngZone.run(() => {
            const navigationExtras = { state: { message: 'Registration Successfull' } };
            this.router.navigate(['/account/login'], navigationExtras).then(() => window.location.reload());
          });
        }
      }, (error) => {
        this.showLoader = false
        // let message = error.error.message;
        // if (message.includes('Http failure response for (unknown url): 0 Unknown Error')) message = 'Please check the internet connection';
        this.toastr.clear();
        this.toastr.error(error)
      });
    }
    resendOTPCode() {
      this.otpErrorMsg = false
      this.ngOtpInputTwoRef.setValue("");
      this.showLoader = true
      let mail = this.signupForm.value.userDetails.userEmail
      var params = {
        otpType: +this.type,
        employeeId: this.employeeId,
        token: this.token,
        merchantId: this.merchantId,
        storeId: this.storeId,
        generationType: "login"
      }
      return this.http.post(this.GLOBALURL + '/user/verify', params, this.httpOptions2).subscribe((response: any) => {
        if (response.success == 1) {
          // this.successmessage = response.message
          // this.clearMessage()
          this.toastr.clear();
          this.toastr.success(response.message);
          this.disabledConfirmBtn = false;
          this.showLoader = false
          this.countdownFunction();
        } else {
          // this.errormessage = response.message
          // this.clearMessage()
          this.toastr.clear();
          this.toastr.error(response.message);
          this.showLoader = false
        }
      }, (error) => {
        this.showLoader = false
        // let message = error.error.message;
        // if (message.includes('Http failure response for (unknown url): 0 Unknown Error')) message = 'Please check the internet connection';
        this.toastr.clear();
        this.toastr.error(error);
        //console.log(error)
      });
    }
    isChecked(type: any) {
      if (type === +this.type) {
        return true
      } else {
        return false
      }
    }
    otp: any = ""
    enableConfirm = false;
    changeOtp(event: any) {
      this.otp = event;
      this.otpErrorMsg = false
      if (this.otp.length == 4) {
        this.enableConfirm = true;
      } else {
        this.enableConfirm = false;
      }
    }
    validateEmail() {
      if (!/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.signupForm.get('userDetails').value.userEmail)) {
        this.emailMsg = "Please enter a valid email";
        return;
      } else {
        this.emailMsg = '';
        this.checkEmailInUse();
      }
    }
    emailMsg: any = "";
    emailExists: boolean = false;
    checkEmailInUse() {
      if (!/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.signupForm.get('userDetails').value.userEmail)) {
        this.emailMsg = "Please enter a valid email";
        return;
      } else {
        var params = {
          username: this.signupForm.get('userDetails').value.userEmail
        }
        return this.http.post(this.GLOBALURL + '/user/check', params, this.httpOptions).subscribe((response: any) => {
          if (response.success == 0) {
            this.emailMsg = response.message;
            this.emailExists = true;
          } else {
            this.emailMsg = '';
            return this.emailExists = false;
          }
        }, (error) => {
          this.emailMsg = error;
          this.emailExists = true;
        });
      }
    }
    showPassword = false;
    togglePassword() {
      this.showPassword = !this.showPassword;
    }
    showConfirmPassword = false;
    toggleConFirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    }



}
